import React from "react";

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from "@mui/material/Typography";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreativeCommons, faCreativeCommonsBy } from '@fortawesome/free-brands-svg-icons'

const PageFooter = () => (
  <Container maxWidth="md">
    <Divider />
    <Box textAlign="center" my={3}>
      <Box component="div" display="inline" mr={1} my="auto">
        <SvgIcon>
          <FontAwesomeIcon icon={faCreativeCommons} />
        </SvgIcon>
        <SvgIcon>
          <FontAwesomeIcon icon={faCreativeCommonsBy} />
        </SvgIcon>
      </Box>
      <Box component="div" display="inline" my="auto">
        <Typography component="span">
          This dataset is licensed under a <a href="https://creativecommons.org/licenses/by/4.0/">
          Creative Commons 4.0 International License
          </a>. <span dangerouslySetInnerHTML={{ "__html": "&copy;" }} />2020-2021 Vasileios Lampos.
        </Typography>
      </Box>
    </Box>
  </Container>
);

export default PageFooter;
